import { useQuery } from '@tanstack/react-query'

import { appointmentApi } from '@services/appointment.service'
import { DEFAULT_CLINIC_TZ } from '@lib/clinicDate'

// Resolves the clinical-availability region (timezone) for a doctor from their
// availability rule, so date displays can adapt their format to that region.
// Falls back to the default clinic timezone when no rule exists yet.
export function useClinicTimezone(doctorId?: string): string {
  const { data } = useQuery({
    queryKey: ['availability-rule', doctorId],
    queryFn: () => appointmentApi.getAvailabilityRule(doctorId as string),
    enabled: !!doctorId,
    staleTime: 5 * 60_000,
    retry: false,
  })
  return data?.timezone || DEFAULT_CLINIC_TZ
}
